import React, {useState, useEffect} from 'react';
import HomeSection from './HomeSection/HomeSection';
import './Home.css';
import Post from '../../../Data/Post';
import ErrorMessage from '../../General/ErrorMessage/ErrorMessage';
import TranslateTag from '../../../Utils/Local/TranslateTag';

const Home = (props) => {

    const [errorStatus, updateErrorStatus] = useState({visible: false, message: ''});
    const [specimenTypes, setSpecimenTypes] = useState([]);
    const [specimenStates, setSpecimenStates] = useState([]);
    const [specimenTags, setSpecimenTags] = useState([]);

    useEffect(() => {
        let criteria = { Name: 'specimentypecount', Parameters: [] };
        Post('query/filteredget', criteria, specimenTypeSuccess, errorWhenRetrievingData);

        criteria = { Name: 'specimenstatecount', Parameters: [] };
        Post('query/filteredget', criteria, setSpecimenStates, errorWhenRetrievingData);

        criteria = { Name: 'specimentagcount', Parameters: [] };
        Post('query/filteredget', criteria, setSpecimenTags, errorWhenRetrievingData);
    }, []);

    const specimenTypeSuccess = (data) => {
        setSpecimenTypes(data);
    }

    const errorCloseHandler = () => {
        updateErrorStatus({visible: false, message: ''});
    }
   
    const errorWhenRetrievingData = (response) => {
        updateErrorStatus({visible: true, message: response.data});
    }

    return (
        <div className='home-page'>
            <div className='managelist-title'>{TranslateTag("@SpeSta@", props.language)}</div>
            <div className='managelist-heading-text'>{TranslateTag("@SpeStaB@", props.language)}</div>
            {/* <Separator></Separator> */}
            <div className="home-content">
                <HomeSection type="state" title={TranslateTag("@SpeStaA@", props.language)} data={specimenStates} onClick={props.onClick}></HomeSection>
                <HomeSection type="specimentype" title={TranslateTag("@SpeTyp@", props.language)} data={specimenTypes} onClick={props.onClick}></HomeSection>
                <HomeSection type="tag" title={TranslateTag("@GenTagB@", props.language)} data={specimenTags} onClick={props.onClick}></HomeSection>
            </div>
            <ErrorMessage visible={errorStatus.visible} dismissHandler={errorCloseHandler} error={errorStatus.message}></ErrorMessage>
        </div>
    )
};

export default Home;